<template>
	<div class="channels-container">
		<LazyTvChannelTile
			v-for="(c, idx) in channels"
			:key="idx"
			:ref="idx"
			:tile="c"
			:big="designOptions.big"
			@tileClicked="toggleTile(idx)"
			:open="idx === openTileId"
			:hide-name="designOptions.hideName"
		/>
	</div>
</template>

<script>
import axios from "axios";
import apiModel from "../models/apiModel.js";

export default defineNuxtComponent({
	name: "TvChannels",

	props: ["channel", "jsonUrl", "designOptions"],

	data() {
		return {
			currentTile: -1,
			apiChannels: [],
			openTileId: null,
			prevOpenTileId: null,
		};
	},

	computed: {
		channels() {
			return (this.apiChannels.length && this.apiChannels) || this.channel;
		},
	},

	methods: {
		toggleTile(idx) {
			const openTileId = idx;
			const currentOpenTile = this.$refs[openTileId][0];
			const prevOpenTile = this.$refs[this.prevOpenTileId];

			if (this.openTileId === openTileId) {
				this.openTileId = null;
				this.prevOpenTileId = null;
				currentOpenTile.setMarginBottom(false);
				prevOpenTile && prevOpenTile[0].setMarginBottom(false);
			} else {
				this.openTileId = openTileId;
				currentOpenTile.setMarginBottom(true);

				if (prevOpenTile) {
					if (prevOpenTile[0].$el.offsetTop === currentOpenTile.$el.offsetTop) {
						// Prevent jumping of content
						setTimeout(() => {
							prevOpenTile[0].setMarginBottom(false);
						}, 250);
					} else {
						prevOpenTile[0].setMarginBottom(false);
					}
				}
				this.prevOpenTileId = openTileId;
			}
		},
	},

	async fetch() {
		if (this.metadata && this.metadata.jsonUrl) {
			const { data } = await axios.get(this.metadata.jsonUrl);
			const channels = data.channels.map(apiModel);
			channels &&
				channels.sort(function (channelA, channelB) {
					let posA, posB;
					if (channelA.sortPosition) posA = parseInt(channelA.sortPosition);
					if (channelB.sortPosition) posB = parseInt(channelB.sortPosition);
					if (!isNaN(posA) && !isNaN(posB)) {
						if (posA > posB) return 1;
						if (posA < posB) return -1;
					}
					return 0;
				});

			this.apiChannels = channels;
		}
	},
});
</script>

<style lang="scss">
.channels-container {
	margin: -$spacing-m;
}
</style>
